import React from "react";

import { TabType, MOBILE } from "@constants";

import { FiltersProps, IconsListProps, LocalizationProps } from "../../../types";

import FiltersMobileToggle from "./FiltersMobileToggle";
import FiltersMobileDropdown from "./FiltersMobileDropdown";

type FiltersMobileProps = {
  type: TabType;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & FiltersProps &
  IconsListProps &
  LocalizationProps;

const FiltersMobile: React.FC<FiltersMobileProps> = ({
  filters,
  iconsList,
  localization,
  type,
  handleOnChange,
}) => {
  return (
    <div id={`filters-${MOBILE}-${type}`} className="sm:hidden">
      <FiltersMobileToggle iconsList={iconsList} localization={localization} type={type} />
      <FiltersMobileDropdown
        filters={filters}
        iconsList={iconsList}
        type={type}
        handleOnChange={handleOnChange}
      />
    </div>
  );
};

export default FiltersMobile;
